export type { ErrorProps } from './Error';
export { Error } from './Error';
